import { useEffect, useState } from "react";
import Layout from "../include/layout";
import Swal from "sweetalert2";
import UsersService from "../../services/UsersService";
import { myroutes } from "../../routes/webroute";
import $ from "jquery"
import { Link, useNavigate } from "react-router-dom";
import { Col, Form, Row } from "react-bootstrap";
import { useSelector } from "react-redux";


export default function ProfilUser(){
     //##########################/// METHODES ##########################///
    //navigate pour faire les redirections
    const [validationError, setValidationError] = useState({})
    const navigate = useNavigate();
    const token = useSelector(state => state.auth.token)

    //Creation des ascesseurs getters et setters pour tout le formulaire
    const [id, setId] = useState('')
    const [nom, setNom] = useState('')
    const [prenoms, setPrenoms] = useState('')
    const [adresse, setAdresse] = useState('')
    const [telephone, setTelephone] = useState('')
    const [email, setEmail] = useState('')
    const [roles, setRoles] = useState([]); 
    const [statut, setStatut] = useState([]);

	const auth = useSelector(state => state.auth)
     //get details data
     const show = async () => {
        await UsersService.show(auth.user.id, token).then((response) => {
            const data = response.data.user
            setId(data.id)
            setNom(data.nom)
            setPrenoms(data.prenoms)
            setAdresse(data.adresse)
            setEmail(data.email)
            setTelephone(data.telephone)
            setRoles(response.data.user_roles.map((defaultRole) => ({
                id: defaultRole.id,
                label: defaultRole.libelle,
            })))
            setStatut(data.statut_id ? data.get_statut.libelle : "")


        }).catch(error => {
            Swal.fire({
                icon: "error",
                text: error.message
            })
            setValidationError(error.message)
        });
    }
    //redirection sur la page edit sans afficher les id dans l'url
    const goToEdit = (param) => {
        navigate(myroutes.users_edit, { state: { id: param } })
    }


    useEffect(() => {
        show();
        $("#submenu-4").addClass("show")
    }, [])

    //##########################/// END METHODES ##########################///

    return(
        <Layout>
            <div className="app-content pt-3 p-md-3 p-lg-4 app-card app-card-stat">
                <div className="container-xl app-card-body">

                    <div className="row g-3 align-items-center justify-content-between">
                        <div className="col-auto">
                            <div className="pagetitle">
                                <h1 className="app-page-title mb-0 text-start">Administration</h1>
                                <nav>
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to={myroutes.dashboard} >Accueil</Link></li>
                                        <li className="breadcrumb-item"><Link to={myroutes.users_index} >Utilisateurs</Link></li>
                                        <li className="breadcrumb-item active">Détails utilisateur </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>{/*//row*/}

                    <div className="row g-3 mb-4 align-items-center justify-content-between">
                        <div className="col-auto">
                            <h1 className="app-page-title mb-0">Détails
                                <span className="btn btn-primary btn-sm mx-3" onClick={() => goToEdit(id)} title="Ajouter" ><i className="fas fa-edit"></i></span></h1>
                        </div>
                    </div>{/*//row*/}

                    <div className="app-card app-card-settings shadow-lg mb-5">
                        <div className="app-card-body py-2 mx-3">

                            <Form className="mx-3 settings-form" style={{ textAlign: "left" }}>

                                <Row>
                                    <Col md={6} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Nom <i className="text-danger">*</i>
                                            </Form.Label>
                                            <Form.Control className="border border-info border rounded-2"
                                                value={nom}
                                                onChange={(e) => setNom(e.target.value)}
                                                placeholder="Votre nom"
                                                name="nom"
                                                aria-label="nom"
                                                type="text"
                                                disabled
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Prénoms <i className="text-danger">*</i>
                                            </Form.Label>
                                            <Form.Control className="border border-info border rounded-2"
                                                value={prenoms}
                                                onChange={(e) => setPrenoms(e.target.value)}
                                                placeholder="Votre prénom"
                                                name="prenom"
                                                aria-label="prenom"
                                                type="text"
                                                disabled
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Téléphone <i className="text-danger"></i>
                                            </Form.Label>
                                            <Form.Control className="border border-info border rounded-2"
                                                value={telephone}
                                                onChange={(e) => setTelephone(e.target.value)}
                                                placeholder=""
                                                name="telephone"
                                                aria-label="telephone"
                                                type="text"
                                                disabled
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Email <i className="text-danger">*</i>
                                            </Form.Label>
                                            <Form.Control className="border border-info border rounded-2"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                placeholder=""
                                                name="email"
                                                aria-label="email"
                                                type="email"
                                                disabled
                                            />
                                        </Form.Group>
                                    </Col>

                                </Row>
                                <Row>
                                    <Col md={4} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Adresse <i className="text-danger"></i>
                                            </Form.Label>
                                            <Form.Control className="border border-info border rounded-2"
                                                value={adresse}
                                                onChange={(e) => setAdresse(e.target.value)}
                                                placeholder=""
                                                name="adresse"
                                                aria-label="adresse"
                                                type="text"
                                                disabled
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={4} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Statuts <i className="text-danger">*</i> </Form.Label>
                                            <Form.Control className="border border-info border rounded-2"
                                                value={statut}
                                                onChange={(e) => setStatut(e.target.value)}
                                                placeholder=""
                                                name="statut"
                                                aria-label="statut"
                                                type="text"
                                                disabled
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={4} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Roles <i className="text-danger">*</i> </Form.Label>
                                            {roles.map((role) => (
                                                <Form.Check
                                                    key={role.id}
                                                    type="checkbox"
                                                    id={role.id}
                                                    label={role.label}
                                                    checked
                                                    readOnly
                                                />
                                            ))}
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Form>

                        </div>{/*//app-card-body*/}
                    </div>
                    {/*//app-card*/}

                </div>{/*//container-fluid*/}
            </div>{/*//app-content*/}
        </Layout>
    )
}